import { render, staticRenderFns } from "./editPlace.vue?vue&type=template&id=cd39adec&scoped=true"
import script from "./editPlace.vue?vue&type=script&lang=js"
export * from "./editPlace.vue?vue&type=script&lang=js"
import style0 from "./editPlace.vue?vue&type=style&index=0&id=cd39adec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd39adec",
  null
  
)

export default component.exports